/**
 * One place for MintStint's price, currency and trial length.
 *
 * The RevenueCat offering is the authority for what a customer is actually
 * charged — a package's `priceText` is localised and reflects whatever the
 * store has. These constants are the fallback for screens that render before
 * an offering has loaded, and for copy that has to name the price in a
 * sentence. Every screen used to hardcode the figure, so changing the price in
 * RevenueCat left the app telling people something untrue.
 *
 * Prefer `usePricing()` in a component; reach for the constants only where a
 * hook is not available.
 */
export const PRO_PRICE_TEXT = "NZ$14.99";

/** ISO code for the price above. Stated in the UI so the amount is unambiguous. */
export const PRO_PRICE_CURRENCY = "NZD";

/**
 * Length of the introductory free trial.
 *
 * Not configured anywhere yet — the RevenueCat Test Store cannot hold a trial,
 * and a real one is an introductory offer created in App Store Connect and Play
 * Console. Until then this is the length the copy promises, not one anybody
 * receives. See REVENUECAT_SETUP.md.
 */
export const PRO_TRIAL_DAYS = 30;

/** MintStint sells to New Zealand only for now. */
export const PRO_REGION_NOTE = "New Zealand only.";

/** "NZ$14.99/month" — the price as it reads mid-sentence. */
export const PRO_PRICE_PER_MONTH = `${PRO_PRICE_TEXT}/month`;

/** "30 days free, then NZ$14.99/month" */
export const PRO_TRIAL_SUMMARY = `${PRO_TRIAL_DAYS} days free, then ${PRO_PRICE_PER_MONTH}`;

/**
 * Resolve the price to show, preferring what the store actually reports.
 *
 * @param offeringPriceText `priceText` from the active RevenueCat package.
 */
export function proPriceText(offeringPriceText?: string | null) {
  return offeringPriceText?.trim() || PRO_PRICE_TEXT;
}

/** As above, suffixed with "/month". */
export function proPricePerMonth(offeringPriceText?: string | null) {
  return `${proPriceText(offeringPriceText)}/month`;
}
